import React from 'react';
import { useVibrancy } from '../VibrancyDashboardContext';

/** VD-SHELL-02 — client-only banner shown when "Group Overview" campus is selected. */
const GroupOverviewBanner: React.FC = () => {
    const { isGroupOverview } = useVibrancy();
    if (!isGroupOverview) return null;

    return (
        <div className="px-3 py-2 mb-3 rounded-3 text-white d-flex align-items-center gap-2 flex-wrap"
            style={{ background: 'linear-gradient(135deg,#5b21b6 0%,#7c3aed 100%)' }}>
            <span className="fw-bold font-14">📊 Group Overview — all campuses combined</span>
            <span style={{ fontSize: 12, color: 'rgba(255,255,255,.7)' }}>Select a specific campus above to drill down</span>
        </div>
    );
};

export default GroupOverviewBanner;
